import {
  SortFilterTraitFilter,
  SortFilterTraitSort,
} from '../../types/sort-filter-trait'

export const syncToQueryParams = ({
  valueArray,
  paramName,
}: {
  valueArray: SortFilterTraitFilter[] | SortFilterTraitSort[]
  paramName: 'sort' | 'filter'
}): void => {
  const searchParams = new URLSearchParams(window.location.search)

  if (valueArray.length === 0) {
    searchParams.delete(paramName)
  } else {
    searchParams.set(paramName, JSON.stringify(valueArray))
  }

  const newUrl = `${window.location.pathname}?${searchParams.toString()}`

  window.history.pushState({}, '', newUrl)
}
